import { useState } from 'react';
import Button from 'components/button';
import JournalRunBlock from './JournalRunBlock';
import { JournalLoadFailed, JournalSkeleton } from './JournalErrorsTab';

/**
 * The "Historique" tab of the import journal (JBWEB-1281, mockup 2.9): one
 * block per run of the month, newest first and unfolded; older runs come a
 * page at a time.
 */
const JournalHistoryTab = ({ runs, text, onShowToFix }) => {
  // Runs whose fold the admin changed; every other block keeps its default.
  const [toggled, setToggled] = useState({});

  if (runs.status === 'loading') {
    return (
      <JournalSkeleton label={text('loading', 'Chargement du journal…')} />
    );
  }
  if (runs.status === 'failed') {
    return <JournalLoadFailed text={text} onReload={runs.reload} />;
  }

  const { page, pages } = runs.data;
  if (runs.data.runs.length === 0) {
    return (
      <div className="py-16 text-center text-gray-500">
        {text('history.empty', 'Aucun import pour ce mois')}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {runs.data.runs.map((run, index) => (
        <JournalRunBlock
          key={run.id}
          run={run}
          text={text}
          isOpen={Boolean(toggled[run.id]) !== (index === 0)}
          onToggle={() =>
            setToggled((previous) => ({
              ...previous,
              [run.id]: !previous[run.id],
            }))
          }
          onShowToFix={onShowToFix}
        />
      ))}
      {page < pages && (
        <Button
          color="SECONDARY"
          size="SM"
          disabled={runs.isLoadingMore}
          onClick={runs.loadMore}
          className="self-center disabled:opacity-50"
        >
          {text('history.older', 'Voir les passages plus anciens')}
        </Button>
      )}
    </div>
  );
};

export default JournalHistoryTab;
